import {Pipe, PipeTransform} from '@angular/core';
import {Card} from '../../../_models/card.model';

@Pipe({
  name: 'totalNeedsReviewCount'
})
export class TotalNeedsReviewCountPipe implements PipeTransform {

  transform(cards: Card[]): number {
    let sum = 0;
    for (const card of cards) {
      sum += card.needsReviewCount;
    }
    return sum;
  }

}

